import React from "react";
import ReactApexChart from "react-apexcharts";

// let colors = ["#f0f9ba", "#fff1ae", "#fed38c", "#feb669", "#f3854e"];
// let colors = ["#1542E6", "#E63A15", "#59E615"];

//let colors = ["#4f81bd", "#c0504d", "#9bbb59" ];
// let colors = ["#4f81bd", "#228B22", "#D22B2B" ];
let colors = ["#00ff00", "#ff8000", "#ff0000" ];

export default class CChart extends React.Component {
  
  constructor(props) {
    super(props);
    console.log(props)
    this.state = {
     
    };
  }

  render() {
   let coptions={
    
      chart: {
        width: 200,
        type: "pie",
      },
      
      colors: colors,

      // title: {
      //   text: 'Water Satisfaction Index Distribution',
      //   align: 'center'
      // },
      
      //labels:this.props.pie_categories,
      labels:["Good (CWSI > 0.6)", "Satisfactory (0.3 < CWSI < 0.6)", "Poor (CWSI < 0.3)"], 
          
      
      // xaxis: {
      //   title:{
      //   text: this.props.xAxisTitle
      //   },
      //   axisTicks: {
      //     show: false
      //   },
      //     type:"category",
      //     categories: this.props.categories,
      //     labels: {
      //       style: {
      //         // colors: colors,
      //         fontSize: '14px'
      //       }
      //     },

      //   },
      //   title: {
      //     text: this.props.title,
      //     align: 'center',
      //     style: {
      //       fontSize: "16px",
      //       color: '#0000ff',
      //       fontSytle:"bold"
      //       // borderColor:"#FF00FF"
      //     }
      //   },

      // yaxis: {
      //   title: {
      //     text: this.props.yAxisTitle,
      //   },
      // },

      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          //  console.log(series,seriesIndex,w)
          return (
            '<div class="arrow_box">' +
            "<span> " +
            w.globals.seriesNames[seriesIndex] +
            ": " +
            series[seriesIndex] + ' ha' + 
            " </span>" +
            "</div>"
          );
        },
      },
      stroke: {
        show: false,
    },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: 'center', 
        itemMargin: {
          horizontal: 5,
          vertical: 0
      },
      },
  
   }

    return (
      <div id="chart" style={{height: '100%'}}>
        <ReactApexChart
          options={coptions}
          series={this.props.series}
          type="pie"
          height={'95%'} 
        />
      </div>
    );
  }
}
